import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SortableColumnService {

    private columnSortedSource = new Subject<ColumnSortedEvent>();
    columnSorted$ = this.columnSortedSource.asObservable();

    constructor() { }

    columnSorted(event: ColumnSortedEvent) {
        // console.log('->-> Servicio de columnSorted: ');
        // console.log(event);
        this.columnSortedSource.next(event);
    }

}

export interface ColumnSortedEvent {
    sortColumn: string;
    sortDirection: string;
    isNumeric: boolean;
}
